import ApiBase from './base/ApiBase'

export default class OrganizationSettingsClient extends ApiBase {
    private controllerName: string = 'Organization';
    
    async GetOrganizationSettings(signal?: AbortSignal): Promise<OrganizationSettingsComplete> {
        return this.GetAsync(`${this.controllerName}/Settings`, signal);
    }

    async UpdateSettings(dto: OrganizationSettings, signal?: AbortSignal): Promise<void> {
        return this.PutAsync(`${this.controllerName}/Settings`, dto, signal);
    }
    
    ExtractOnlySettings = (settings: OrganizationSettingsComplete): OrganizationSettings => {
        const temp = JSON.stringify(settings);
        const onlySettings = JSON.parse(temp);
    
        delete onlySettings.Descriptions;
    
        return onlySettings;
    }

    async GetOnlySettings(signal?: AbortSignal): Promise<OrganizationSettings> {
        const settings = await new OrganizationSettingsClient().GetOrganizationSettings(signal);
        const onlySettings = this.ExtractOnlySettings(settings);

        return onlySettings;
    }
}

export interface OrganizationSettings {
    DefaultProfileName: string,
    DisplayFirstNameThenLast: boolean,
    RemoveAssesmentSelections: boolean,
    DevelopmentPlanMin: number,
    DevelopmentPlanMax: number,
    SubscriptionOverride: boolean,
}

export interface OrganizationSettingsComplete extends OrganizationSettings {
    Descriptions: {[key: string]: string},
}

export enum OrganizationSettingsErrors {
    GetAll = 'Error loading Organization Settings',
    Update = 'Error saving Organization Settings',
}
